export default "__VITE_ASSET__DdkYKfA1__"